import { useEffect, useState } from "react";
import { postAccount } from "./accountApi";
import useCurrentUser from "./useCurrentUser";

// Posts an action to the SavedListings servlet (/savedlistings)
export const listingAction = (action, body = {}) => postAccount('/savedlistings', {action, ...body});

// Whether the user can use the listing pages: null until known, then
// {signedin, subscribed}, or {error} when the server couldn't be asked.
// Asked again when someone logs in or out.
const useListingAccess = () => {
    const user = useCurrentUser();
    const [access, setAccess] = useState(null);
    const email = user && user.signedin ? user.email : null;
    const known = !!user;

    useEffect(() => {
        if (!known) return undefined;
        let stopped = false;
        setAccess(null);
        listingAction('status')
            .then((reply) => { if (!stopped) setAccess(reply); })
            .catch(() => { if (!stopped) setAccess({error:"We couldn't reach trackmystreet. Check your connection and reload the page."}); });
        return () => { stopped = true; };
    }, [email, known]);

    return access;
};

export default useListingAccess;

// The last subscription answer, as {email, subscribed}, so menus don't change from page to page
let knownSub = null;

// Who the menus are for: {signedIn, subscribed, waiting}. Each page asks again; until it hears,
// the last answer for this user stands. With none yet, waiting is true and the options that
// depend on it wait.
export const useSubscribed = () => {
    const user = useCurrentUser();
    const access = useListingAccess();
    const signedIn = !!(user && user.signedin);
    const heard = !!(access && !access.error);
    if (signedIn && heard) knownSub = {email:user.email, subscribed:!!access.subscribed};
    const remembered = signedIn && knownSub && knownSub.email === user.email ? knownSub.subscribed : null;
    const subscribed = signedIn && (heard ? !!access.subscribed : remembered === true);
    const waiting = signedIn && !heard && remembered === null;
    return {user, signedIn, subscribed, waiting};
};
